import { IrrigationSource, ServiceType } from "@agroyaar/sdk";
import { waterMarkerIcon } from "../../../../../../components/map/utils/customs";
import AgroMapPoint from "../../../../../../features/map/presentation/components/AgroMapPoint";
import { toolbarBaseControls } from "../../../../../../features/map/utils/configs";
import { reportColor } from "../../../utils/report-color";

interface IrrigationSourceInformationProps {
  irrigationSource: IrrigationSource;
  serviceType: ServiceType;
}

const IrrigationSourceInformation = ({
  irrigationSource,
  serviceType,
}: IrrigationSourceInformationProps) => {
  const colorCode = reportColor(serviceType);
  return (
    <div className="flex flex-col justify-center items-start w-1/2 gap-2">
      <span className="font-bold text-[20px] !font-[B-Nazanin] text-[#222]">
        {" "}
        اطلاعات منبع آبی
      </span>

      <div className="flex flex-row justify-start items-center gap-[19px] w-full">
        <div
          className="relative overflow-hidden  rounded-full w-[80px] h-[80px]"
          style={{ border: `2px solid ${colorCode}` }}
        >
          <div className="THISISFORMAPLOCK! bg-transparent z-[99999999] w-full h-full absolute"></div>
          <AgroMapPoint
            key={irrigationSource?.id}
            type="onlyShow"
            mapId={irrigationSource?.id + "irrigation"}
            markerIcon={waterMarkerIcon}
            // @ts-ignore
            toolbarOptions={toolbarBaseControls}
            currentPoint={irrigationSource?.location.coordinates}
          />
        </div>
        <div className="flex flex-col justify-center items-start gap-[6px] font-bold text-[16px]">
          <div className="flex flex-row items-start gap-[8px]">
            <span className="font-bold text-[18px] !font-[B-Nazanin]">
              نام منبع:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {irrigationSource.name}
            </span>
          </div>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="font-bold text-[18px] !font-[B-Nazanin]">
              استان:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {irrigationSource.province.name}
            </span>
          </div>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="font-bold text-[18px] !font-[B-Nazanin]">
              شهر:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {irrigationSource.city.name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IrrigationSourceInformation;
